import formatConstructionType from "@/utils/formatConstructionType";
import { AllProjectConstructionTypes } from "@/consts/ArchitectureDetail";
import { SelectionProps } from "@/interfaces/SelectionProps";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { ArchitectureSearchQueryParameter } from "@/types/ArchitectureSearchQueryParameter";
import RadioTile from "@/components/RadioTile";
import SearchScafold from "@/components/SearchScafold";

const registerKey: keyof ArchitectureSearchQueryParameter = "construction_type";
type ConstructionTypeFormField = Pick<
  ArchitectureSearchQueryParameter,
  "construction_type"
>;

const ConstructionTypeSelection: FC<
  SelectionProps<ConstructionTypeFormField>
> = ({ defaultValue, onUpdate, onBack }): JSX.Element => {
  const { register, handleSubmit } = useForm<ConstructionTypeFormField>();

  return (
    <SearchScafold
      handleSubmit={handleSubmit((data) => {
        onUpdate(data);
        onBack();
      })}
      title={"工事種別"}
    >
      <ul className="BorderList">
        <li>
          <RadioTile
            value={""}
            register={register(registerKey)}
            label={"指定なし"}
            defaultChecked={defaultValue?.construction_type == ""}
          />
        </li>

        {AllProjectConstructionTypes.map((v) => (
          <li key={v}>
            <RadioTile
              defaultChecked={defaultValue === v.toString()}
              value={v.toString()}
              register={register(registerKey)}
              label={formatConstructionType(v)}
            />
          </li>
        ))}
      </ul>
    </SearchScafold>
  );
};
export default ConstructionTypeSelection;
